import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../config/firebase';

const COLLECTION = 'fundPeriodSummaries';

/**
 * @param {string} lenderUid
 * @param {string} periodKey - YYYY-MM
 * @returns {Promise<object | null>}
 */
export async function getFundPeriodSummaryForLenderOnce(lenderUid, periodKey) {
  if (!lenderUid || !periodKey || !/^\d{4}-\d{2}$/.test(periodKey)) return null;
  const ref = doc(firestore, COLLECTION, `${lenderUid}_${periodKey}`);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}
